var app = angular.module('leonardo');

var UnitTypeService = function(BaseRestService, RestangularProvider) {
  var service = new BaseRestService('unit-type');

  service.deleteUnitsType = function(params) {
    return RestangularProvider.all('unit-type').customDELETE('delete-type', params);
  };

  service.getUnitTypeOnBasisOfMultipleProperty = function(data){
    return RestangularProvider.all('unit-type').customPOST(data, 'multi-property');
  }

  return service;
};

app.factory('UnitTypeService', ['BaseRestService', 'Restangular', UnitTypeService]);
